import React from 'react';
import { Route, Switch } from 'react-router-dom';

import AssignUserForm from '../../../CycleCount/AssignUser/index';

import CycleCountConfirmationForm from '../../../CycleCount/CycleCountConfirmation/index';
import CCCaptureReason from '../../../CycleCount/CCCaptureReason/index';

import CycleCountDashboardForm from '../../../CycleCount/CycleCountDashboard/index';
import CycleCountRecommendationForm from '../../../CycleCount/CycleCountRecommendation/index';
import createNew from '../../../CycleCount/createNew/index';





export default () => (
  <Switch>
    <Route path="/cycleCount/assignUser" component={AssignUserForm} />
    <Route path="/cycleCount/cycleCountConfirmation" component={CycleCountConfirmationForm} />
    <Route path="/cycleCount/cc_capture_reason" component={CCCaptureReason} />
    <Route path="/cycleCount/CycleCountReport" component={CycleCountDashboardForm} />
    <Route path="/cycleCount/create_new" component={createNew} />

	<Route path="/cycleCount/CycleCountRecommendation" component={CycleCountRecommendationForm} />
    
    
  </Switch>
);
